import React from "react";
import { Route, useRouteMatch, Switch } from "react-router-dom";
import NotificationsList from "./NotificationsList";
import AddEditNotification from "./AddEditNotification";

const SiteNotificationsPage = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/edit/:notificationId`} component={AddEditNotification} />

            <Route path={`${path}/edit`} component={AddEditNotification} />

            <Route path={path} component={NotificationsList} />
        </Switch>
    );
};

export default SiteNotificationsPage;
